// extracted by mini-css-extract-plugin
module.exports = {"itemRow":"ItemCounterRow_itemRow__2nE9R","label":"ItemCounterRow_label__1MNMK","subText":"ItemCounterRow_subText__3pNR_","img":"ItemCounterRow_img__3b7Qw"};